import { Ticket } from "callable-data-objects";
import React from "react";
import { Label } from "semantic-ui-react";

type TicketStatusLabelProps = {
  ticket: Ticket;
};
const TicketStatusLabel = ({ ticket }: TicketStatusLabelProps) => {
  switch (ticket.status) {
    case "closed":
      return (
        <Label as="a" color="grey" basic>
          Closed
        </Label>
      );
    case "pending":
      return (
        <Label as="a" color="blue" basic>
          Pending
        </Label>
      );
    case "open":
      return (
        <Label as="a" color="red" basic>
          Open
        </Label>
      );
  }
  throw new Error("Unknown ticket type " + ticket.status);
};

export default TicketStatusLabel;
